var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-input",
    _vm._b(
      {
        staticClass: "form-control",
        attrs: {
          name: _vm.id,
          state: _vm.state,
          type: "date",
          value: _vm.date,
        },
        on: { change: _vm.handleChange },
      },
      "b-input",
      _vm.additionalInputAttributes,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }